import React, { useEffect, useState } from 'react';
import './HeroCarousel.css';

const SLIDES = [
  { src: '/index/banner1.png', alt: 'Faynet - Internet residencial, mais conexão para a sua casa' },
  { src: '/index/banner2.png', alt: 'Faynet - Planos e ofertas de internet' },
];

const AUTOPLAY_MS = 6000;

function HeroCarousel() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % SLIDES.length);
    }, AUTOPLAY_MS);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="hero-carousel">
      {SLIDES.map((slide, index) => (
        <img
          key={slide.src}
          src={slide.src}
          alt={slide.alt}
          className={`hero-carousel__slide ${index === current ? 'hero-carousel__slide--active' : ''}`}
        />
      ))}

      <div className="hero-carousel__dots">
        {SLIDES.map((slide, index) => (
          <button
            key={slide.src}
            type="button"
            className={`hero-carousel__dot ${index === current ? 'hero-carousel__dot--active' : ''}`}
            onClick={() => setCurrent(index)}
            aria-label={`Ir para o slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
}

export default HeroCarousel;
